import angular from 'angular';
import Mailcheck from 'mailcheck';
import { includes } from 'lodash';

module.exports = angular.module('market.directives.od-mailcheck', [])
.directive('odMailcheck', function odMailcheck() {
  if (typeof(Mailcheck) === 'undefined') {
    console.warn('od-mailcheck requires the Mailcheck library.');
    return {};
  }

  Mailcheck.defaultTopLevelDomains = [
    "com", "net", "org", "info", "edu",
  ];
  Mailcheck.defaultDomains = [
    "yahoo.com", "google.com", "hotmail.com", "gmail.com", "me.com", "aol.com",
    "mac.com", "live.com", "comcast.net", "googlemail.com", "msn.com",
    "facebook.com", "verizon.net", "sbcglobal.net", "att.net", "mail.com",
    "outlook.com", "icloud.com","cox.net",
  ];

  const BLACKLISTED_TLDS = [
    'como', 'comp', 'con', 'met', 'ner', 'vom'
  ];

  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      scope.$watch(attrs.ngModel, function(email) {
        Mailcheck.run({
          email: email,
          suggested: function suggested(suggestion) {
            scope.$eval(attrs.odMailcheck + '=' + JSON.stringify(suggestion.full));
          },
          empty: function empty() {
            scope.$eval(attrs.odMailcheck + '=null');
          }
        });

        if (email && ngModel) {
          let tokens = email.split('.');
          let tld = tokens[tokens.length - 1];
          let valid = !includes(BLACKLISTED_TLDS, tld);
          ngModel.$setValidity('blacklisting-tld', valid);
        }
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/directives/od-mailcheck.js
 **/